<script>
import EmptyStateBlock from '@/components/general/empty-state-block.vue'
import UserAvatar from '@/components/user/user-avatar.vue'
import baseMixin from '@/mixins/baseMixin'

export default {
  name: 'BookingDetailsTabConfirmations',
  components: {
    EmptyStateBlock,
    UserAvatar,
  },
  mixins: [baseMixin],
  props: {
    booking: {
      type: Object,
      required: true,
    },
  },
  computed: {
    confirmations() {
      return this.booking.details.confirmations
    },
    hasConfirmations() {
      return this.confirmations.length > 0
    },
  },
  methods: {
    getSMSNumber(item) {
      return item.sms?.number || ''
    },
    getVoiceNumber(item) {
      return item.voice?.number || ''
    },
  },
}
</script>

<template>
  <div>
    <EmptyStateBlock
      v-if="!hasConfirmations"
      border
      icon="mdi-account-alert"
      :title="'No confirmation contacts'"
      :description="
        'No one will receive notifications with updates for this booking'
      "
    />
    <v-simple-table v-else fixed-header height="300px">
      <template v-slot>
        <thead>
          <tr>
            <th class="text-left">
              {{ $t('booking.details.confirmations.table.nameColumn') }}
            </th>
            <th class="text-left">
              {{ $t('booking.details.confirmations.table.emailColumn') }}
            </th>
            <th class="text-left">
              {{ $t('booking.details.confirmations.table.smsColumn') }}
            </th>
            <th class="text-left">
              {{ $t('booking.details.confirmations.table.voiceColumn') }}
            </th>
            <!-- <th class="text-left">
              {{
                $t('booking.details.confirmations.table.pushNotificationColumn')
              }}
            </th> -->
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in confirmations" :key="item.name">
            <td class="d-flex align-center"
              ><UserAvatar :name="item.name" size="xs" class="mr-2" />
              <p class="mb-0 font-weight-medium">{{ item.name }}</p></td
            >
            <td>
              <BaseLink
                v-if="item.email"
                :title="
                  $t('booking.details.confirmations.table.emailLinkTooltip')
                "
                :href="`mailto:${item.email}`"
                target="_self"
                >{{ item.email }}</BaseLink
              >
            </td>
            <td>
              <BaseLink
                v-if="getSMSNumber(item)"
                :title="
                  $t('booking.details.confirmations.table.smsLinkTooltip')
                "
                :href="`tel:${getSMSNumber(item)}`"
                target="_self"
                >{{ getSMSNumber(item) }}</BaseLink
              >
            </td>
            <td>
              <BaseLink
                v-if="getVoiceNumber(item)"
                :title="
                  $t('booking.details.confirmations.table.voiceLinkTooltip')
                "
                :href="`tel:${getVoiceNumber(item)}`"
                target="_self"
                >{{ getVoiceNumber(item) }}</BaseLink
              ></td
            >
            <!-- <td>
              <v-icon
                v-if="item.pushNotifications"
                :title="
                  $t(
                    'booking.details.confirmations.table.pushNotificationLinkTooltip'
                  )
                "
                >mdi-check</v-icon
              ></td
            > -->
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>
